module.exports = __webpack_public_path__ + "static/media/Frame1.8d387e5f.png";